var site = site || {};

site.cliniqueSppSliderMobileV1 = site.cliniqueSppSliderMobileV1 || {};
site.gotL2Cache = false;

(function ($) {
  cliniqueSppSliderMobileV1 = {
    formatter: $('.clinique-spp-slider-mobile-v1'),
    formatterParent: $('.cl-spp-slider-formatter-mobile-v1')
  };

  Drupal.behaviors.cliniqueSppSliderMobileV1 = {
    get: function (key) {
      return cliniqueSppSliderMobileV1[key];
    },
    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.once('clinique-spp-slider-mobile-v1-processed').each(function () {
        var thisFormatter = $(this);
        var thisFormatterParent = thisFormatter.parents(self.get('formatterParent').selector);
        // $('.slider-large', thisFormatter).hide();
        var slider_img = thisFormatterParent.find('.outer-wrap').attr('data-sliderimg');

        // $(".slider-thumb", thisFormatter).find('a').bind("click",function(){
        // $(".slider-thumb", thisFormatterParent).find('.step-image').css("border", "1px solid transparent");
        // $(this).find('.step-image', thisFormatterParent).css("border","1px solid #000");
        // $('.slider-large', thisFormatterParent).hide();
        thisFormatter.find('.slider-large').show();
        $('.handle img', thisFormatter).attr('src', slider_img);
        // });
        $('.second', thisFormatter).slider({
          marginY: 20,
          marginX: 20,
          setX: 160,
          setY: 300,
          direction: 'horizontal'
        });
      });
      self.get('formatterParent').each(function () {
        var thisFormatterParent = $(this);

        $('.slider-thumb:first a', thisFormatterParent).trigger('click');
      });
    }
  };
})(jQuery);
